<template>
  <div class="FormInscripcion">
    <div v-if="FormInscripcion">
      <form-wizard @on-complete="onComplete" next-button-text="Siguiente" back-button-text="Regresar" finish-button-text="Finalizar" title subtitle color="#222">
        <tab-content :title="this.labelFields.fields1" icon="ti-target" :before-change="beforeTabSwitch1">
          <div class="container">
            <div class="row d-flex flex-column">
              <div v-if="alertfound" class="alert alert-danger" role="alert">
                Estimado usuario. Tus datos no han podido ser validados por nuestro sistema de información. Te invitamos a comunicarte a nuestra línea de atención al estudiante 7426582 Opción 2 o a través del correo servicioalestudiante@ibero.edu.co.
              </div>
              <div class="col infoForm">
                <FormDataInscription /> 
              </div> 
              <div class="col totalform">  
                <div v-if="infoData" class="alert alert-danger">
                  <p>
                    Estimado usuario. Tus datos no han podido ser validados por nuestro sistema de información. Te invitamos a comunicarte a nuestra línea de atención al estudiante 7426582 Opción 2 o a través del correo servicioalestudiante@ibero.edu.co.
                  </p>
                </div>
                <ValidationObserver ref="obsFields1">
                  <FormInscription :FieldsForm="formInscription.fields1" :ModelForm="formInsModel" :method="executeProcess" />                                     
                </ValidationObserver>
              </div>       
            </div>
          </div>
        </tab-content>
        <tab-content :title="this.labelFields.fields2" icon="ti-user" :before-change="beforeTabSwitch2">
          <div class="container">
            <div class="row">
              <div class="col-md-12 totalform">         
                <div v-if="infoPregunta" class="alert alert-success">
                  <p>
                    Estimado(a) estudiante: Para este requerimiento, la Institución cuenta con un (01) día hábil para enviarte respuesta al correo registrado. Recuerda que cuentas con módulos de autogestión para agilizar tus procesos, ingresando a “Hazlo tú mismo” en <a href="https://www.ibero.edu.co/estudiantes-hazlo-tu-mismo/">https://www.ibero.edu.co/estudiantes-hazlo-tu-mismo/</a>
                  </p>
                </div>
                <div v-if="infoQueja" class="alert alert-success">
                  <p>
                    Estimado(a) estudiante: Para este requerimiento, la Institución cuenta con diez (10) días hábiles para atender tu queja y quince (15) días hábiles para atender tu reclamación. Se enviará respuesta al correo registrado.
                  </p>
                </div>
                <div v-if="infoSolicitud" class="alert alert-success">
                  <p>
                    Estimado(a) estudiante: Para este requerimiento, la Institución cuenta entre cinco (5) y diez (10) días hábiles para atender tu solicitud. Se enviará respuesta al correo registrado.
                  </p>
                </div>

                <div v-if="infoCarta" class="alert alert-warning">
                  <p>
                    Estimado(a) estudiante: Por favor no olvides adjuntar a este requerimiento la carta explicativa, comentando tu caso y poder atenderte. Se enviará respuesta al correo registrado.
                    Recuerda que tu caso será gestionado y tramitado con la documentación completa.
                  </p>
                </div>
                <div v-if="infoSoporte" class="alert alert-warning">
                  <p>
                    Estimado(a) estudiante: Por favor no olvides adjuntar a este requerimiento el soporte del pago - Certificación bancaria no superior a 30 días, para poder atenderte. Se enviará respuesta al correo registrado.
                    Recuerda que tu caso será gestionado y tramitado con la documentación completa.
                  </p>
                </div>
                <div v-if="infoRecibo" class="alert alert-warning">
                  <p>
                    Estimado(a) estudiante: Por favor no olvides adjuntar a este requerimiento el recibo de pago de inscripción contenidos programáticos oficialmente expedidos por la institución de origen paz y salvo de la institución 
                    de origen - Certificado de notas expedidos por la institución de origen donde especifique intensidad horaria, número de créditos y calificación obtenida, para poder atenderte. Se enviará respuesta al correo registrado.
                    Recuerda que tu caso será gestionado y tramitado con la documentación completa.
                  </p>
                </div>
                <div v-if="infoConvalidar" class="alert alert-warning">
                  <p>
                    Estimado(a) estudiante: Para la creación del caso se debe contar con todos los documentos requeridos, de lo 
                    contrario se cierra y debe iniciarse nuevamente el proceso.
                    <br/>
                    <strong>Sólo se realizan envíos digitales, no se hacen envíos físicos</strong>
                  </p>
                </div>

                <ValidationObserver ref="obsFields2">
                  <FormInscription :FieldsForm="formInscription.fields2" :ModelForm="this.formInsModel" :method="executeProcess" />
                </ValidationObserver>
              </div>
            </div>
          </div>
        </tab-content>
      </form-wizard>  
    </div>
    <div v-if="!FormInscripcion" class="FormInscripcionOK">
      <form-wizard next-button-text="" back-button-text="" finish-button-text="" title subtitle color="#222">
        <tab-content title="Registro Exitoso" icon="ti-thumb-up" :before-change="beforeTabSwitch1">
          <div class="container">
            <div class="row totalform">              
              <div class="col-md-12 ">  
                <div class="alert" role="alert">
                  <center><H3>¡Hola!</H3></center>
                  <br>
                  <p>Gracias, Tu información ha sido recibida  con éxito, se ha creado el caso No.<strong> {{this.sendCase}} </strong></p>
                  <p>Tu asesor de servicio en el termino de 24 a 48 horas hábiles te confirmará a través de correo electrónico el tiempo de respuesta de tu requerimiento</p>
                  <br>
                </div>   
                <div v-if="alertnofile" class="alert alert-danger noShow" role="alert">
                  Se ha generado un problema con el documento cargado, por favor intenta nuevamente.
                </div>  
                <div v-if="alertfile" class="alert alert-success" role="alert">
                  <center><H3>¡Hola!</H3></center>
                  <br>
                  <p>Gracias, Tu información ha sido recibida  con éxito, se ha creado el caso No.<strong> {{this.sendCase}} </strong></p>
                  <p>Tu asesor de servicio en el termino de 24 a 48 horas hábiles te confirmará a través de correo electrónico el tiempo de respuesta de tu requerimiento</p>
                  <br>
                </div>
              </div>           
            </div>
          </div>
        </tab-content>             
      </form-wizard>
    </div>
  </div>
</template>

<script>
import FormDataInscription from '@/views/InfoZone/FormPQRS.vue'
import FormInscription from '@/components/Forms.vue'
import IberoHelpers from '@/store/helpers.js'

export default {  
  name: "FormInscripcion",
  components: {
    FormDataInscription,
    FormInscription,
  },
  methods: {
    payOrder: function(){
      let loader = this.$loading.show();
      var NamePeriod = IberoHelpers.dataObjFind(this.$store.state.PeriodoList,this.formInsModel.IdConvoca).split(' ')[0];
      var res = IberoHelpers.getRegistrationPayOrder(this.$store.state.ApiIbero.WSUtilitary,this.formInsModel.IdDocument,NamePeriod);
      var dataLink = this.$store.state.ApiIbero.WSIceBerg;
      res.then(Response => {
                if (Response.data[0].numPayOrder != null && Response.data[0].numPayOrder != "") {
                   window.open(dataLink+"/recibo_pago.zul?numero=" + Response.data[0].numPayOrder + "&tipo=I", "_blank");
                  }
              })
      loader.hide();
    },
    dataObjCheck: function(InfDaT){
      if(InfDaT === true){
        return this.$ml.get('Accepted');   
      }
      return this.$ml.get('NotAccepted');    
    },
    valNacionality: function(InfDat){
      if(document.getElementById("sum_IdStateBirth") != null){
        if (InfDat.IdNacionality != 169) {
          document.getElementById("sum_IdStateBirth").classList.add('noShow');
          document.getElementById("sum_IdCityBirth").classList.add('noShow');
        } else {
          document.getElementById("sum_IdStateBirth").classList.remove('noShow');
          document.getElementById("sum_IdCityBirth").classList.remove('noShow');
        }
      }
    },
    loadFindData: function(restJson){
      this.formInsModel.IdNombres = restJson.nombres
      this.formInsModel.IdApellidosS = restJson.apellidos
      this.formInsModel.IdBanner = restJson.idBanner
      this.formInsModel.IdHomePhone = restJson.telefono
      this.formInsModel.IdCelPhone = restJson.celular
      this.formInsModel.IdMail = restJson.emailInstitucional
      this.formInsModel.IdCountry = restJson.codPais
      this.formInsModel.IdState = restJson.codDepartamento
      this.formInsModel.IdCity = restJson.codCiudad
      if (this.formInsModel.IdCountry != 169) {
        document.getElementById("div_IdState").classList.add('noShow');
        document.getElementById("div_IdCity").classList.add('noShow');
        this.formInsModel.IdState = '11'
        this.formInsModel.IdCity = '11001'
      } else {
        document.getElementById("div_IdState").classList.remove('noShow');
        document.getElementById("div_IdCity").classList.remove('noShow');
        this.formInsModel.IdState = ''
        this.formInsModel.IdCity = ''            
      }
      IberoHelpers.getCitiesListByState(this.$store.state.ApiIbero.WSParametric,this.$store.state.CityList,restJson.codDepartamento);
      this.formInscription.fields1[6].values = this.$store.state.CityList
      this.formInsModel.IdState = restJson.codDepartamento
      this.formInsModel.IdCity = restJson.codCiudad
      this.formInsModel.IdWorking = restJson.modalidad
      this.formInsModel.IdProgram = restJson.programa

      document.getElementById("IdNombres").readOnly = true;
      document.getElementById("IdApellidosS").readOnly = true;
      document.getElementById("IdBanner").readOnly = true;
      document.getElementById("Subject").readOnly = true;
      return true
    },
    dataformat: function(InfDaT){
      return IberoHelpers.dataObjDate(InfDaT);
    },
    dataObjFindJs: function(infoDaT,FinDaT){        
      return IberoHelpers.dataObjFind(infoDaT,FinDaT);
    },
    dataObjAllFind: function(infoDaT,FinDaT){        
      return IberoHelpers.dataObjAllFind(infoDaT,FinDaT);
    },    
    executeProcess: async function (event) {
      //this.formUserFileModel = [];
      switch (event.target.id) {
        case "IdDocType":
          this.formInsModel.IdDocument = '';
        break; 
        case "IdDocument":
            if(event.type === 'blur' && this.formInsModel.IdDocType !== '' && this.formInsModel.IdDocument !== '') {
              var pruebaUser = IberoHelpers.findUserBannerComplete(this.$store, this.formInsModel);
              pruebaUser.then(Response => {
                if (Response.data.length > 0) {            
                  this.infoData = false;
                  this.loadFindData(Response.data[0])
                }
                else
                {
                  this.infoData = true;
                }
              })
            }
        break;   
        /* Apartado para que cambio texto en files */
        case 'PTL_ERROR':
          event.target.nextElementSibling.innerText = event.target.files[0].name
          this.formInsModel.PTL_ERROR = event.target.files[0].name
          // const campoPTL_ERROR = this.formInscription.fields2.find(field => field.id === 'PTL_ERROR');
          // campoPTL_ERROR.validate.required = false;
          this.formUserFileModel.push({ filedata: event.target.files[0] })
        break;
        case 'CMPBT_PAGO':
          event.target.nextElementSibling.innerText = event.target.files[0].name
          this.formInsModel.CMPBT_PAGO = event.target.files[0].name
          // const campoCMPBT_PAGO = this.formInscription.fields2.find(field => field.id === 'CMPBT_PAGO');
          // campoCMPBT_PAGO.validate.required = false;
          this.formUserFileModel.push({ filedata: event.target.files[0] })
        break;
        case 'FOT_DOC':
          event.target.nextElementSibling.innerText = event.target.files[0].name
          this.formInsModel.FOT_DOC = event.target.files[0].name
          // const campoFOT_DOC = this.formInscription.fields2.find(field => field.id === 'FOT_DOC');
          // campoFOT_DOC.validate.required = false;
          this.formUserFileModel.push({ filedata: event.target.files[0] })
        break;
        case 'FRM_INSC': 
          event.target.nextElementSibling.innerText = event.target.files[0].name
          this.formInsModel.FRM_INSC = event.target.files[0].name
          // const campoFRM_INSC = this.formInscription.fields2.find(field => field.id === 'FRM_INSC');
          // campoFRM_INSC.validate.required = false;
          this.formUserFileModel.push({ filedata: event.target.files[0] })
        break;
        case 'FMRT_TERM': 
          event.target.nextElementSibling.innerText = event.target.files[0].name
          this.formInsModel.FMRT_TERM = event.target.files[0].name
          // const campoFMRT_TERM = this.formInscription.fields2.find(field => field.id === 'FMRT_TERM');
          // campoFMRT_TERM.validate.required = false;
          this.formUserFileModel.push({ filedata: event.target.files[0] })
        break;
        case 'SOP_PAG':
          event.target.nextElementSibling.innerText = event.target.files[0].name
          this.formInsModel.SOP_PAG = event.target.files[0].name
          // const campoSOP_PAG = this.formInscription.fields2.find(field => field.id === 'SOP_PAG');
          // campoSOP_PAG.validate.required = false;
          this.formUserFileModel.push({ filedata: event.target.files[0] })
        break;
        case 'FOT_CC':
          event.target.nextElementSibling.innerText = event.target.files[0].name
          this.formInsModel.FOT_CC = event.target.files[0].name
          // const campoFOT_CC = this.formInscription.fields2.find(field => field.id === 'FOT_CC');
          // campoFOT_CC.validate.required = false;
          this.formUserFileModel.push({ filedata: event.target.files[0] })
        break;
        case 'DOC_RESPL': 
          event.target.nextElementSibling.innerText = event.target.files[0].name
          this.formInsModel.DOC_RESPL = event.target.files[0].name
          // const campoDOC_RESPL = this.formInscription.fields2.find(field => field.id === 'DOC_RESPL');
          // campoDOC_RESPL.validate.required = false;
          this.formUserFileModel.push({ filedata: event.target.files[0] })
        break;
        case 'DIPLM':
          event.target.nextElementSibling.innerText = event.target.files[0].name
          this.formInsModel.DIPLM = event.target.files[0].name
          // const campoDIPLM = this.formInscription.fields2.find(field => field.id === 'DIPLM');
          // campoDIPLM.validate.required = false;
          this.formUserFileModel.push({ filedata: event.target.files[0] })
        break;
        case 'ACTA':
          event.target.nextElementSibling.innerText = event.target.files[0].name
          this.formInsModel.ACTA = event.target.files[0].name
          // const campoACTA = this.formInscription.fields2.find(field => field.id === 'ACTA');
          // campoACTA.validate.required = false;
          this.formUserFileModel.push({ filedata: event.target.files[0] })
        break;
        case 'AUT_EST':   
          event.target.nextElementSibling.innerText = event.target.files[0].name
          this.formInsModel.AUT_EST = event.target.files[0].name
          // const campoAUT_EST = this.formInscription.fields2.find(field => field.id === 'AUT_EST');
          // campoAUT_EST.validate.required = false;
          this.formUserFileModel.push({ filedata: event.target.files[0] })
        break;
        case 'CRT_SOL':
          event.target.nextElementSibling.innerText = event.target.files[0].name
          this.formInsModel.CRT_SOL = event.target.files[0].name
          // const campoCRT_SOL = this.formInscription.fields2.find(field => field.id === 'CRT_SOL');
          // campoCRT_SOL.validate.required = false;
          this.formUserFileModel.push({ filedata: event.target.files[0] })
        break;
        case 'CRT_FAC':
          event.target.nextElementSibling.innerText = event.target.files[0].name
          this.formInsModel.CRT_FAC = event.target.files[0].name
          // const campoCRT_FAC = this.formInscription.fields2.find(field => field.id === 'CRT_FAC');
          // campoCRT_FAC.validate.required = false;
          this.formUserFileModel.push({ filedata: event.target.files[0] })
        break;
        case 'CRT_MAN': 
          event.target.nextElementSibling.innerText = event.target.files[0].name
          this.formInsModel.CRT_MAN = event.target.files[0].name
          // const campoCRT_MAN = this.formInscription.fields2.find(field => field.id === 'CRT_MAN');
          // campoCRT_MAN.validate.required = false;
          this.formUserFileModel.push({ filedata: event.target.files[0] })
        break;
        case 'FOR_OPR':  
          event.target.nextElementSibling.innerText = event.target.files[0].name
          this.formInsModel.FOR_OPR = event.target.files[0].name
          // const campoFOR_OPR = this.formInscription.fields2.find(field => field.id === 'FOR_OPR');
          // campoFOR_OPR.validate.required = false;
          this.formUserFileModel.push({ filedata: event.target.files[0] })
        break;
        case 'CERT_COMP':
          event.target.nextElementSibling.innerText = event.target.files[0].name
          this.formInsModel.CERT_COMP = event.target.files[0].name
          // const campoCERT_COMP = this.formInscription.fields2.find(field => field.id === 'CERT_COMP');
          // campoCERT_COMP.validate.required = false;
          this.formUserFileModel.push({ filedata: event.target.files[0] })
        break;
        case 'CERT_BANC':
          event.target.nextElementSibling.innerText = event.target.files[0].name
          this.formInsModel.CERT_BANC = event.target.files[0].name
          // const campoCERT_BANC = this.formInscription.fields2.find(field => field.id === 'CERT_BANC');
          // campoCERT_BANC.validate.required = false;
          this.formUserFileModel.push({ filedata: event.target.files[0] })
        break;
        case 'CAR_FORM':
          event.target.nextElementSibling.innerText = event.target.files[0].name
          this.formInsModel.CAR_FORM = event.target.files[0].name
          // const campoCAR_FORM = this.formInscription.fields2.find(field => field.id === 'CAR_FORM');
          // campoCAR_FORM.validate.required = false;
          this.formUserFileModel.push({ filedata: event.target.files[0] })
        break;
        case 'SAB_11':
          event.target.nextElementSibling.innerText = event.target.files[0].name
          this.formInsModel.SAB_11 = event.target.files[0].name
          // const campoSAB_11 = this.formInscription.fields2.find(field => field.id === 'SAB_11');
          // campoSAB_11.validate.required = false;
          this.formUserFileModel.push({ filedata: event.target.files[0] })
        break;
        case 'SAB_PRO':
          event.target.nextElementSibling.innerText = event.target.files[0].name
          this.formInsModel.SAB_PRO = event.target.files[0].name
          // const campoSAB_PRO = this.formInscription.fields2.find(field => field.id === 'SAB_PRO');
          // campoSAB_PRO.validate.required = false;
          this.formUserFileModel.push({ filedata: event.target.files[0] })
        break;
        case 'FORM_OP':
          event.target.nextElementSibling.innerText = event.target.files[0].name
          this.formInsModel.FORM_OP = event.target.files[0].name
          // const campoFORM_OP = this.formInscription.fields2.find(field => field.id === 'FORM_OP');
          // campoFORM_OP.validate.required = false;
          this.formUserFileModel.push({ filedata: event.target.files[0] })
        break;
        case 'DIPL_ACT':
          event.target.nextElementSibling.innerText = event.target.files[0].name
          this.formInsModel.DIPL_ACT = event.target.files[0].name
          // const campoDIPL_ACT = this.formInscription.fields2.find(field => field.id === 'DIPL_ACT');
          // campoDIPL_ACT.validate.required = false;
          this.formUserFileModel.push({ filedata: event.target.files[0] })
        break;
        case 'ADJ_DOC':
          event.target.nextElementSibling.innerText = event.target.files[0].name
          this.formInsModel.ADJ_DOC = event.target.files[0].name
          // const campoDIPL_ACT = this.formInscription.fields2.find(field => field.id === 'DIPL_ACT');
          // campoDIPL_ACT.validate.required = false;
          this.formUserFileModel.push({ filedata: event.target.files[0] })
        break;
        case 'DOC_1':
          event.target.nextElementSibling.innerText = event.target.files[0].name
          this.formInsModel.DOC_1 = event.target.files[0].name
          // const campoDIPL_ACT = this.formInscription.fields2.find(field => field.id === 'DIPL_ACT');
          // campoDIPL_ACT.validate.required = false;
          this.formUserFileModel.push({ filedata: event.target.files[0] })
        break;
        case 'DOC_2':
          event.target.nextElementSibling.innerText = event.target.files[0].name
          this.formInsModel.DOC_2 = event.target.files[0].name
          // const campoDIPL_ACT = this.formInscription.fields2.find(field => field.id === 'DIPL_ACT');
          // campoDIPL_ACT.validate.required = false;
          this.formUserFileModel.push({ filedata: event.target.files[0] })
        break;
        case 'DOC_3':
          event.target.nextElementSibling.innerText = event.target.files[0].name
          this.formInsModel.DOC_3 = event.target.files[0].name
          // const campoDIPL_ACT = this.formInscription.fields2.find(field => field.id === 'DIPL_ACT');
          // campoDIPL_ACT.validate.required = false;
          this.formUserFileModel.push({ filedata: event.target.files[0] })
        break;
        case 'DOC_4':
          event.target.nextElementSibling.innerText = event.target.files[0].name
          this.formInsModel.DOC_4 = event.target.files[0].name
          // const campoDIPL_ACT = this.formInscription.fields2.find(field => field.id === 'DIPL_ACT');
          // campoDIPL_ACT.validate.required = false;
          this.formUserFileModel.push({ filedata: event.target.files[0] })
        break;
        case 'DOC_5':
          event.target.nextElementSibling.innerText = event.target.files[0].name
          this.formInsModel.DOC_5 = event.target.files[0].name
          // const campoDIPL_ACT = this.formInscription.fields2.find(field => field.id === 'DIPL_ACT');
          // campoDIPL_ACT.validate.required = false;
          this.formUserFileModel.push({ filedata: event.target.files[0] })
        break;
        case 'DOC_6':
          event.target.nextElementSibling.innerText = event.target.files[0].name
          this.formInsModel.DOC_6 = event.target.files[0].name
          // const campoDIPL_ACT = this.formInscription.fields2.find(field => field.id === 'DIPL_ACT');
          // campoDIPL_ACT.validate.required = false;
          this.formUserFileModel.push({ filedata: event.target.files[0] })
        break;
        case 'DOC_7':
          event.target.nextElementSibling.innerText = event.target.files[0].name
          this.formInsModel.DOC_7 = event.target.files[0].name
          // const campoDIPL_ACT = this.formInscription.fields2.find(field => field.id === 'DIPL_ACT');
          // campoDIPL_ACT.validate.required = false;
          this.formUserFileModel.push({ filedata: event.target.files[0] })
        break;
        case 'DOC_8':
          event.target.nextElementSibling.innerText = event.target.files[0].name
          this.formInsModel.DOC_8 = event.target.files[0].name
          // const campoDIPL_ACT = this.formInscription.fields2.find(field => field.id === 'DIPL_ACT');
          // campoDIPL_ACT.validate.required = false;
          this.formUserFileModel.push({ filedata: event.target.files[0] })
        break;
        case 'DOC_9':
          event.target.nextElementSibling.innerText = event.target.files[0].name
          this.formInsModel.DOC_9 = event.target.files[0].name
          // const campoDIPL_ACT = this.formInscription.fields2.find(field => field.id === 'DIPL_ACT');
          // campoDIPL_ACT.validate.required = false;
          this.formUserFileModel.push({ filedata: event.target.files[0] })
        break;
        case 'DOC_10':
          event.target.nextElementSibling.innerText = event.target.files[0].name
          this.formInsModel.DOC_10 = event.target.files[0].name
          // const campoDIPL_ACT = this.formInscription.fields2.find(field => field.id === 'DIPL_ACT');
          // campoDIPL_ACT.validate.required = false;
          this.formUserFileModel.push({ filedata: event.target.files[0] })
        break;
        /* Apartado para que cambio texto en files */
        case "IdCountry":
          this.formInsModel.IdState = '';
          this.formInsModel.IdCity = '';
          if(event.target.value === ''){            
            this.formInscription.fields1[8].values = '';
          }else{
            IberoHelpers.getStatesListByCountry(this.$store.state.ApiIbero.WSParametric,this.$store.state.StateList,event.target.value);
            this.formInscription.fields1[9].values = this.$store.state.StateList;
          }
        break;     
        case "IdState":
          this.formInsModel.IdCity = '';
          if(event.target.value === ''){            
            this.formInscription.fields1[9].values = '';
          }else{
            IberoHelpers.getCitiesListByState(this.$store.state.ApiIbero.WSParametric,this.$store.state.CityList,event.target.value);
            this.formInscription.fields1[10].values = this.$store.state.CityList;
          }
        break;  
        case "IdPQRS":
          var resultado =  IberoHelpers.dataObjFind(this.$store.state.PQRSList, this.formInsModel.IdPQRS);
          switch(resultado){
            case "Pregunta":
              this.infoPregunta = true;
              this.infoQueja = false;
              this.infoCarta = false;
              this.infoCarta = false;
              this.infoSoporte = false;
              this.infoRecibo = false;
              this.infoConvalidar = false;
              this.formInscription.fields2[2].validate.required = false;
              this.formInscription.fields2[4].validate.required = false;
            break;
            case "Queja":
              this.infoPregunta = false;
              this.infoQueja = true;
              this.infoSolicitud = false;
              this.infoCarta = false;
              this.infoSoporte = false;
              this.infoRecibo = false;
              this.infoConvalidar = false;
              this.formInscription.fields2[2].validate.required = false;
              this.formInscription.fields2[4].validate.required = false;
            break;
            case "Solicitud":
              this.infoPregunta = false ;
              this.infoQueja = false;
              this.infoSolicitud = true;
              this.infoCarta = false;
              this.infoSoporte = false;
              this.infoRecibo = false;
              this.infoConvalidar = false;
              this.formInscription.fields2[2].validate.required = false;
              this.formInscription.fields2[4].validate.required = false;
            break;
            case "Trámite":
              this.infoPregunta = false;
              this.infoQueja = false;
              this.infoSolicitud = false;
              this.infoCarta = false;
              this.infoSoporte = false;
              this.infoRecibo = false;
              this.infoConvalidar = false;
              this.formInscription.fields2[2].validate.required = true;
              //this.formInscription.fields2[4].validate.required = true;
              break;
          }
          this.formInsModel.IdSubject = '';
          if(event.target.value === ''){            
            this.formInscription.fields2[6].values = '';
          }else{
            IberoHelpers.getItemsListByPQRS(this.$store.state.ApiIbero.WSParametric,this.$store.state.ItemList,event.target.value);
            this.formInscription.fields2[6].values = this.$store.state.ItemList;
          }
        break;  
        case "IdSubject":
          var valorTramite = IberoHelpers.dataObjFind(this.$store.state.ItemList, this.formInsModel.IdSubject);
          switch(valorTramite){
            case "CAMBIO DE JORNADA":
              this.infoCarta = true;
              this.infoSoporte = false;
              this.infoRecibo = false;
              this.infoConvalidar = false;
              break;
            case "CAMBIO DE MODALIDAD":
              this.infoCarta = true;
              this.infoSoporte = false;
              this.infoRecibo = false;
              this.infoConvalidar = false;
              break;
            case "CAMBIO DE PROGRAMA":
              this.infoCarta = true;
              this.infoSoporte = false;
              this.infoRecibo = false;
              this.infoConvalidar = false;
              break;
            case "CARGA COMPLETA":
              this.infoCarta = true;
              this.infoSoporte = false;
              this.infoRecibo = false;
              this.infoConvalidar = false;
              break;
            case "MEDIA CARGA":
              this.infoCarta = true;
              this.infoSoporte = false;
              this.infoRecibo = false;
              this.infoConvalidar = false;
              break;
            case "CUARTO DE CARGA":
              this.infoCarta = true;
              this.infoSoporte = false;
              this.infoRecibo = false;
              this.infoConvalidar = false;
              break;
            case "CRÉDITOS ADICIONALES":
              this.infoCarta = true;
              this.infoSoporte = false;
              this.infoRecibo = false;
              this.infoConvalidar = false;
              break;
            /* case "RESERVA DE CUPO": // Eliminar
              this.infoCarta = true;
              this.infoSoporte = false;
              this.infoRecibo = false;
              this.infoConvalidar = false;
              break; */
            /* case "RESERVA DE CUPO - ABONO DE DINERO": // Eliminar
              this.infoCarta = true;
              this.infoSoporte = false;
              this.infoRecibo = false;
              this.infoConvalidar = false;
              break; */
            /* case "RESERVA DE CUPO - ANULACIÓN CRÉDITO ESTUDIA YA": // Eliminar
              this.infoCarta = true;
              this.infoSoporte = false;
              this.infoRecibo = false;
              this.infoConvalidar = false;
              break; */
            /* case "RESERVA DE CUPO - DEVOLUCIÓN DE DINERO": // Eliminar
              this.infoCarta = false;
              this.infoSoporte = true;
              this.infoRecibo = false;
              this.infoConvalidar = false;
              break; */
            case "APLAZAMIENTO DE PERIODO ACADÉMICO": // Cambio en soporte
              this.infoCarta = true;
              this.infoSoporte = false;
              this.infoRecibo = false;
              this.infoConvalidar = false;
              break;
            case "CANCELACIÓN DE PERIODO ACADÉMICO": // Cambio en soporte
              this.infoCarta = true;
              this.infoSoporte = false;
              this.infoRecibo = false;
              this.infoConvalidar = false;
              break;
            /* case "CANCELACIÓN - ABONO DINERO": // Eliminar
              this.infoCarta = true;
              this.infoSoporte = false;
              this.infoRecibo = false;
              this.infoConvalidar = false;
              break; */
            /* case "CANCELACIÓN - ANULACIÓN CRÉDITO ESTUDIA YA": // Eliminar
              this.infoCarta = true;
              this.infoSoporte = false;
              this.infoRecibo = false;
              this.infoConvalidar = false;
              break; */
            /* case "CANCELACIÓN - DEVOLUCIÓN DE DINERO": // Eliminar
              this.infoCarta = false;
              this.infoSoporte = true;
              this.infoRecibo = false;
              this.infoConvalidar = false;
              break; */
            case "SOLICITUD DE GRADO POR VENTANILLA":
              this.infoCarta = true;
              this.infoSoporte = false;
              this.infoRecibo = false;
              this.infoConvalidar = false;
              break;
            case "REINGRESO CON CAMBIO DE PROGRAMA":
              this.infoCarta = true;
              this.infoSoporte = false;
              this.infoRecibo = false;
              this.infoConvalidar = false;
              break;
            case "TRÁMITE ACADÉMICO CON ABONO DE DINERO":
              this.infoCarta = false;
              this.infoSoporte = true;
              this.infoRecibo = false;
              this.infoConvalidar = false;
              break;
            case "TRÁMITE ACADÉMICO CON DEVOLUCIÓN DE DINERO":
              this.infoCarta = false;
              this.infoSoporte = true;
              this.infoRecibo = false;
              this.infoConvalidar = false;
              break;
            case "SALDO A FAVOR Y/O DEVOLUCIÓN O ABONO":
              this.infoCarta = false;
              this.infoSoporte = true;
              this.infoRecibo = false;
              this.infoConvalidar = false;
              break;
            case "MATRICULA DE HONOR - SOLICITUD DE DEVOLUCIONES Y/O ABONOS":
              this.infoCarta = false;
              this.infoSoporte = true;
              this.infoRecibo = false;
              this.infoConvalidar = false;
              break;
            case "CONVALIDACIÓN DE TÍTULOS EN EL EXTERIOR":
              this.infoCarta = false;
              this.infoSoporte = false;
              this.infoRecibo = false;
              this.infoConvalidar = true;
              break;
            default:
              this.infoCarta = false;
              this.infoSoporte = false;
              this.infoRecibo = false;
              this.infoConvalidar = false;
              break;
          }
          var prueba = IberoHelpers.dataObjFind(this.$store.state.ItemList, event.target.value);
          var tipoTramite =  IberoHelpers.dataObjFind(this.$store.state.PQRSList, this.formInsModel.IdPQRS);
          if(prueba === "OTRO"){
            document.getElementById("Subject").readOnly = false;
            this.formInscription.fields2[2].validate.required = true;
          }else if(tipoTramite === "Trámite"){
            document.getElementById("Subject").readOnly = false;
            this.formInscription.fields2[2].validate.required = true;
          }else{
            document.getElementById("Subject").readOnly = true;
            this.formInscription.fields2[2].validate.required = false;
          }

          var idTramite = IberoHelpers.ValuedataObjFind(this.$store.state.ItemList, this.formInsModel.IdSubject);
          IberoHelpers.getFilesByIdSubject(this.$store.state.ApiIbero.WSParametric, idTramite)
          .then(resultado => {

            const camposDeArchivos = [
              'PTL_ERROR','CMPBT_PAGO','FOT_DOC','FRM_INSC','FMRT_TERM','SOP_PAG',
              'FOT_CC','DOC_RESPL','DIPLM','ACTA','AUT_EST',
              'CRT_SOL','CRT_FAC','CRT_MAN','FOR_OPR','CERT_COMP', 'CERT_BANC', 'CAR_FORM',
              'SAB_11', 'SAB_PRO', 'FORM_OP', 'DIPL_ACT', 'ADJ_DOC', 'DOC_1', 'DOC_2', 'DOC_3',
              'DOC_4', 'DOC_6', 'DOC_7', 'DOC_8', 'DOC_9', 'DOC_10'
            ];
            // Ocultar todos los campos por defecto
            this.formInscription.fields2.forEach(campo => {
              if (campo.type === 'file') {
                campo.hidden = true;
              }
            });

            // Mostrar los campos presentes en el resultado del servicio
            camposDeArchivos.forEach(campoId => {
                const campo = this.formInscription.fields2.find(field => field.id === campoId);
                if (campo && resultado.some(result => result.Cod_FileItem === campoId)) {
                    campo.hidden = false; // Mostrar el campo
                }
            });
          })
          .catch(error => {
            console.log(error);
          });

        break;  
        case "cbox_IdTermiCondi":                   
          event.target.disabled = true;
        break; 
        return true;
      }        
    },
    onComplete: function() {
      this.alertdanger = false;
      return new Promise((resolve, reject) => {
          this.$refs.obsFields2.validate().then(results => {
            if (!results) {
              IberoHelpers.scrollToTop(0,300);
              resolve(false)
            }else{
              let loader = this.$loading.show();
              var tipoTramite =  IberoHelpers.dataObjFind(this.$store.state.PQRSList, this.formInsModel.IdPQRS);
              console.log(tipoTramite)
              if(tipoTramite == "Trámite"){
                var generatePDF = IberoHelpers.sendGenerationPDF(this.$store, 1, 'TRAMPDF', this.formInsModel);
                generatePDF.then(
                  Response => { 
                  let valueRef;
                  let URIFilePDF;
                  let refeFilePDF = []
                  valueRef = "[{\"Id_File\":" + Response.data[0].Id_File + "}]"
                  URIFilePDF = Response.data[0].Det_URI + Response.data[0].Nam_File
                  refeFilePDF = []  
                  refeFilePDF.push({valueRef, URIFile: URIFilePDF})
                  if (Response === false || Response.status != 200){
                    this.alertdanger = true;
                    resolve(false);
                  }
                  else {
                    var totalinf = IberoHelpers.sendFormPQRS(this.$store,this.formInsModel);  
                    totalinf.then(
                      Response => {
                        let numCase  = Response.data.title;
                        this.sendCase = numCase;
                        IberoHelpers.scrollToTop(0,320);
                        if(Response === false || Response.data.status != 200 ){
                          this.alertdanger = true;
                          resolve(false);
                        }else{
                          try{                      
                            this.sumaryData = Response.data.message;
                            if (this.sumaryData != null){
                              //Archivo PDF creado 
                              var FilePDF = {
                                IdSendPQRSDetail: numCase,
                                FileDetail: refeFilePDF,
                              }
                              var resulEndPDF = IberoHelpers.sendFilesByPQRSZoho(this.$store, FilePDF, numCase);
                              resulEndPDF.then(Response => {
                                if (this.formUserFileModel.length > 0){
                                  var dataFile = IberoHelpers.sendUpdloadFile(this.$store, this.formUserFileModel, 'PQRS', 0)
                                  dataFile.then(Response => {
                                    if (!(Response === false)){
                                      for (var i=0; i < Response.length; i++){
                                        let valueRef = Response[i].wsDocument.data.id_File
                                        let URIFile = Response[i].wsDocument.data.filePath
                                        let refeFile = []  
                                        refeFile.push({valueRef, URIFile: URIFile})
                                        var FileZoho = {
                                          IdSendPQRSDetail: numCase,
                                          FileDetail: refeFile,
                                        }
                                        var resulEnd = IberoHelpers.sendFilesByPQRSZoho(this.$store, FileZoho, numCase);
                                        resulEnd.then(Response => {
                                          if (!(Response === false)) {
                                              if (Response.data.status === '200') {                                
                                                loader.hide();
                                                this.alertnofile = true
                                                IberoHelpers.scrollToTop(0,500);
                                                this.FormInscripcion = false;
                                                resolve(true)
                                              } else {
                                                loader.hide();
                                                this.alertdanger = true;
                                                resolve(false)
                                              }
                                          } else {
                                            loader.hide();
                                            this.alertdanger = true;
                                            resolve(false)
                                          }                               
                                        })
                                      }
                                    }
                                  })
                                }else {
                                  loader.hide();
                                  this.alertnofile = true
                                  IberoHelpers.scrollToTop(0,500);
                                  this.FormInscripcion = false;
                                  resolve(true)
                                }
                              })
                            }
                          }catch(error) {    
                            loader.hide();         
                            this.alertdanger = true;
                            resolve(false);
                          };                    
                        }
                      }
                    )
                  }
                })
              } else {
                var totalinf = IberoHelpers.sendFormPQRS(this.$store,this.formInsModel);  
                totalinf.then(
                  Response => {
                    let numCase  = Response.data.title;
                    this.sendCase = numCase;
                    IberoHelpers.scrollToTop(0,320);
                    if(Response === false || Response.data.status != 200 ){                    
                      this.alertdanger = true;
                      resolve(false);
                    }else{
                      try{                      
                        //this.sumaryData = JSON.parse(Response.data.message)[0]
                        this.sumaryData = Response.data.message;
                        if (this.sumaryData != null){
                          //this.FormInscripcion = false;
                          //resolve(true);
                          if (this.formUserFileModel.length > 0) {
                            var dataFile = IberoHelpers.sendUpdloadFile(this.$store, this.formUserFileModel, 'PQRS', 0)
                            dataFile.then(Response => {
                              //this.fileSummary = Response.data.message;
                              if (!(Response === false)){
                                  for (var i=0; i < Response.length; i++) {
                                      let valueRef = Response[i].wsDocument.data.id_File
                                      let URIFile = Response[i].wsDocument.data.filePath
                                      let refeFile = []  
                                      refeFile.push({valueRef, URIFile: URIFile})
                                      var FileZoho = {
                                        IdSendPQRSDetail: numCase,
                                        FileDetail: refeFile,
                                      }
                                      var resulEnd = IberoHelpers.sendFilesByPQRSZoho(this.$store, FileZoho, numCase);
                                      resulEnd.then(Response => {
                                        if (!(Response === false)) {
                                            if (Response.data.status === '200') {                                
                                              loader.hide();
                                              this.alertnofile = true
                                              IberoHelpers.scrollToTop(0,500);
                                              this.FormInscripcion = false;
                                              resolve(true)
                                            } else {
                                              loader.hide();
                                              this.alertdanger = true;
                                              resolve(false);  
                                            }
                                        } else {
                                          loader.hide();
                                          this.alertdanger = true;
                                          resolve(false);  
                                        }                               
                                      })
                                  }                      
                              } else {
                                  this.alertnofile = true
                                  loader.hide()                                                                 
                                  resolve(false)
                              }
                            })
                          } else {
                            loader.hide();
                            IberoHelpers.scrollToTop(0,500);
                            this.FormInscripcion = false;
                            resolve(true)
                          }

                        }else{
                          loader.hide();
                          this.alertdanger = true;
                          resolve(false);  
                        }           
                      }catch(error) {    
                        loader.hide();         
                        this.alertdanger = true;
                        resolve(false);
                      };                    
                    }
                  }
                )
              }
            }            
          });
      });
    },
    beforeTabSwitch1: function() {               
      return new Promise((resolve, reject) => {
          this.$refs.obsFields1.validate().then(results => {         
            if (!results) {
              IberoHelpers.scrollToTop(0,500);
              resolve(false)
            }else{
              IberoHelpers.sendFormPQRSTemp(this.$store,this.formInsModel);
              resolve(true)
            }
          });
      });
    }
  },
  data() {
    return {
      FormInscripcion: true,
      alertdanger: false,
      alertfound: false,
      infoData: false,
      infoPregunta: false,
      infoQueja: false,
      infoSolicitud: false,
      infoCarta: false,
      infoSoporte: false,
      infoRecibo: false,
      infoConvalidar: false,
      sumaryData: [],
      sendCase: [],
      labelFields:{
        fields1:'Datos Usuario',
        fields2:'Formulario de Requerimiento',
      },
      formInsModel: {
        Campaign: this.$route.params.referencia,
        IdDocType: '',
        IdDocument: '',
        IdState: '',
        IdCity: '',
        IdNombres : '',
        IdApellidosS: '',
        IdBanner: '', 
        IdCelPhone: '', 
        IdHomePhone: '', 
        IdMail: '',
        IdCity: '',
        IdTermiCondi: '',
        IdBond: '',
        IdCountry: '169',
        IdYearTitu:  (new Date).getFullYear(),
        IdPQRS: '',
        IdSubject: '',
        Subject: '',
        Description: '',
        Feedback: '',
        /* APARTADO ARCHIVOS */
        PTL_ERROR: '',
        CMPBT_PAGO: '',
        FOT_DOC: '',
        FRM_INSC: '',
        FMRT_TERM: '',
        SOP_PAG: '',
        FOT_CC: '',
        DOC_RESPL: '',
        DIPLM: '',
        ACTA: '',
        AUT_EST: '',
        CRT_SOL: '',
        CRT_FAC: '',
        CRT_MAN: '',
        FOR_OPR: '',
        CERT_COMP: '',
        CERT_BANC: '',
        CAR_FORM: '',
        SAB_11: '',
        SAB_PRO: '',
        FORM_OP: '',
        DIPL_ACT: '',
        DOC_1: '',
        DOC_2: '',
        DOC_3: '',
        DOC_4: '',
        DOC_5: '',
        DOC_6: '',
        DOC_7: '',
        DOC_8: '',
        DOC_9: '',
        DOC_10: '',
        /* FINAL APARTADO ARCHIVOS */
        IdWorking: '',
        IdProgram: '',
        
      }, 
      formInscription:{       
        fields1:[
          {            
            id: 'IdDocType',
            model: 'IdDocType',
            name: 'Tipo de Documento',
            type: 'Select',  
            placeholder: "Tipo de Documento",
            values: this.$store.state.DocTypesList,
            validate: {              
              required: true              
            },
            class: 'col-md-12',
          },
          {            
            id: 'IdDocument',
            model: 'IdDocument',
            name: 'Documento de Identidad',
            type: 'input',  
            placeholder: 'Documento de Identidad',
            values: '',
            validate: {              
              required: true, 
              min: 5,              
              max: 12            
            },
            class: 'col-md-12',        
          },
          {            
            id: 'IdNombres',
            model: 'IdNombres',
            name: 'Nombres',
            type: 'input',  
            placeholder: 'Nombres',
            values: '',
            readonly:"isReadOnly",
            validate: {              
              required: false, 
            },
            class: 'col-md-12',
          },
          {            
            id: 'IdApellidosS',
            model: 'IdApellidosS',
            name: 'Apellidos',
            type: 'input',  
            placeholder: 'Apellidos',
            values: '',
            validate: {              
              required: false              
            },
            class: 'col-md-12'               
          },
          {            
            id: 'IdBanner',
            model: 'IdBanner',
            name: 'Código Estudiantil',
            type: 'input',  
            placeholder: 'Código Estudiantil',
            values: '',
            validate: {              
              required: true, 
              min: 5,              
              max: 12            
            },
            class: 'col-md-12'               
          },     
          {            
            id: 'IdHomePhone',
            model: 'IdHomePhone',
            name: 'Teléfono Fijo',
            type: 'input',  
            placeholder: 'Teléfono Fijo',
            values: '',
            validate: {
              required: false, 
              numeric: true,
              max: 7
            },
            class: 'col-md-12'               
          },           
          {            
            id: 'IdCelPhone',
            model: 'IdCelPhone',
            name: 'Teléfono Celular',
            type: 'input',  
            placeholder: 'Teléfono Celular',
            values: '',
            validate: {
              required: true, 
              numeric: true,
              max: 10,
              min: 10 
            },  
            class: 'col-md-12'               
          },  
          {            
            id: 'IdMail',
            model: 'IdMail',
            name: 'Correo Electrónico',
            type: 'input',  
            placeholder: 'Correo Electrónico',
            values: '',
            validate: {
              required: true, 
              email: true 
            },
            class: 'col-md-12'               
          },
          {
            id: 'IdCountry',
            model: 'IdCountry',
            name: 'País de Residencia',
            type: 'Select',  
            placeholder: 'País de Residencia',
            validate: {              
              required: true              
            },
            class: 'col-md-12',
            values: this.$store.state.CountriesList,
          },
          {
            id: 'IdState',
            model: 'IdState',
            name: 'Departamento de Residencia',
            type: 'Select',  
            placeholder: 'Departamento de Residencia',
            validate: {              
              required: true              
            },
            class: 'col-md-12',            
            values: this.$store.state.StateList,
          },
          {
            id: 'IdCity',
            model: 'IdCity',
            name: 'Ciudad de Residencia',
            type: 'Select',  
            placeholder: 'Ciudad de Residencia',
            validate: {              
              required: true              
            },
            class: 'col-md-12',            
            values: this.$store.state.CityList,
          },
          {
            id: 'IdBond',
            model: 'IdBond',
            name: 'Vínculo con la Institución',
            type: 'Select',  
            placeholder: 'Vínculo con la Institución',
            validate: {              
              required: true              
            },
            class: 'col-md-12',            
            values: this.$store.state.BondsList,
          },      
        ],
        fields2:[
          {
            id: 'IdPQRS',
            model: 'IdPQRS',
            name: 'Tipo de Requerimiento',
            type: 'Select',  
            placeholder: 'Tipo de Requerimiento',
            validate: {              
              required: true              
            },
            class: 'col-md-12',            
            values: this.$store.state.PQRSList,
          },
          {
            id: 'IdSubject',
            model: 'IdSubject',
            name: 'Petición',
            type: 'Select',  
            placeholder: 'Seleccione una petición',
            validate: {              
              required: true              
            },
            class: 'col-md-6',            
            values: this.$store.state.ItemList,
          },
          {
            id: 'Subject',
            model: 'Subject',
            name: 'Asunto',
            type: 'input',  
            placeholder: 'Asunto',
            values: this.$store.state.Select,
            validate: {              
              required: false,
              max: 100,
            },
            class: 'col-md-6'               
          },
          {
            id: 'Description',
            model: 'Description',
            name: 'Detalle de la incidencia ',
            type: 'textarea',  
            placeholder: 'Detalle de la incidencia ',
            values: '',
            validate: {              
              required: true              
            },
            class: 'col-md-12'               
          },
          {
            id: 'Feedback',
            model: 'Feedback',
            name: 'Sugerencia de Mejora para la IBERO',
            type: 'textarea',  
            placeholder: 'Detalle de la Sugerencia de Mejora para la IBERO',
            values: '',
            validate: {              
              required: false              
            },
            class: 'col-md-12',
          },
          /* APARTADO PARA ARCHIVOS */
          {
            id: 'PTL_ERROR',
            placeholder: 'Examinar',
            name: 'Pantallazo del error presentado',
            type: 'file',
            values: '',
            validate: {
              required: false,
            },
            class: 'col-md-12',
            hidden: true
          }, 
          {
            id: 'CMPBT_PAGO',
            placeholder: 'Examinar',
            name: 'Comprobante de pago',
            type: 'file',
            values: '',
            validate: {
              required: false,
            },
            class: 'col-md-12',
            hidden: true
          }, 
          {
            id: 'FOT_DOC',
            placeholder: 'Examinar',
            name: 'Foto tipo documento (No PDF)',
            type: 'file',
            values: '',
            validate: {
              required: false,
            },
            class: 'col-md-12',
            hidden: true
          }, 
          {
            id: 'FRM_INSC',
            placeholder: 'Examinar',
            name: 'Formulario de inscripción',
            type: 'file',
            values: '',
            validate: {
              required: false,
            },
            class: 'col-md-12',
            hidden: true
          }, 
          {
            id: 'FMRT_TERM',
            placeholder: 'Examinar',
            name: 'Formato terminos y condiciones',
            type: 'file',
            values: '',
            validate: {
              required: false,
            },
            class: 'col-md-12',
            hidden: true
          }, 
          {
            id: 'SOP_PAG',
            placeholder: 'Examinar',
            name: 'Soporte de pago',
            type: 'file',
            values: '',
            validate: {
              required: false,
            },
            class: 'col-md-12',
            hidden: true
          }, 
          {
            id: 'FOT_CC',
            placeholder: 'Examinar',
            name: 'Fotocopia de la cc',
            type: 'file',
            values: '',
            validate: {
              required: false,
            },
            class: 'col-md-12',
            hidden: true
          }, 
          {
            id: 'DOC_RESPL',
            placeholder: 'Examinar',
            name: 'Documento de respaldó con foto ( pasaporte, licencia de conducción, etc)',
            type: 'file',
            values: '',
            validate: {
              required: false,
            },
            class: 'col-md-12',
            hidden: true
          }, 
          {
            id: 'DIPLM',
            placeholder: 'Examinar',
            name: 'Diploma',
            type: 'file',
            values: '',
            validate: {
              required: false,
            },
            class: 'col-md-12',
            hidden: true
          }, 
          {
            id: 'ACTA',
            placeholder: 'Examinar',
            name: 'Acta',
            type: 'file',
            values: '',
            validate: {
              required: false,
            },
            class: 'col-md-12',
            hidden: true
          }, 
          {
            id: 'AUT_EST',
            placeholder: 'Examinar',
            name: 'Autorizacion del estudiante',
            type: 'file',
            values: '',
            validate: {
              required: false,
            },
            class: 'col-md-12',
            hidden: true
          }, 
          {
            id: 'CRT_SOL',
            placeholder: 'Examinar',
            name: 'Carta con la solicitud del estudiante',
            type: 'file',
            values: '',
            validate: {
              required: false,
            },
            class: 'col-md-12',
            hidden: true
          }, 
          {
            id: 'CRT_FAC',
            placeholder: 'Examinar',
            name: 'Carta enviada por la facultad',
            type: 'file',
            values: '',
            validate: {
              required: false,
            },
            class: 'col-md-12',
            hidden: true
          }, 
          {
            id: 'CRT_MAN',
            placeholder: 'Examinar',
            name: 'Carta en donde manifiestes tu solicitud y los motivos de esta',
            type: 'file',
            values: '',
            validate: {
              required: false,
            },
            class: 'col-md-12',
            hidden: true
          }, 
          {
            id: 'FOR_OPR',
            placeholder: 'Examinar',
            name: 'Formato cambio de operador',
            type: 'file',
            values: '',
            validate: {
              required: false,
            },
            class: 'col-md-12',
            hidden: true
          }, 
          {
            id: 'CERT_COMP',
            placeholder: 'Examinar',
            name: 'Cerificado de caja de compensación',
            type: 'file',
            values: '',
            validate: {
              required: false,
            },
            class: 'col-md-12',
            hidden: true
          }, 
          {
            id: 'CERT_BANC',
            placeholder: 'Examinar',
            name: 'Certificado bancario',
            type: 'file',
            values: '',
            validate: {
              required: false,
            },
            class: 'col-md-12',
            hidden: true
          }, 
          {
            id: 'CAR_FORM',
            placeholder: 'Examinar',
            name: 'Carta formal',
            type: 'file',
            values: '',
            validate: {
              required: false,
            },
            class: 'col-md-12',
            hidden: true
          }, 
          {
            id: 'SAB_11',
            placeholder: 'Examinar',
            name: 'SABER 11 (Pregrado)',
            type: 'file',
            values: '',
            validate: {
              required: false,
            },
            class: 'col-md-12',
            hidden: true
          }, 
          {
            id: 'SAB_PRO',
            placeholder: 'Examinar',
            name: 'SABER PRO (Pregrado), T&T (Técnico) ... Resultados o Certificado de Asistencia',
            type: 'file',
            values: '',
            validate: {
              required: false,
            },
            class: 'col-md-12',
            hidden: true
          }, 
          {
            id: 'FORM_OP',
            placeholder: 'Examinar',
            name: 'Formato cambio de operador',
            type: 'file',
            values: '',
            validate: {
              required: false,
            },
            class: 'col-md-12',
            hidden: true
          },  
          {
            id: 'DIPL_ACT',
            placeholder: 'Examinar',
            name: 'Acta o Diploma',
            type: 'file',
            values: '',
            validate: {
              required: false,
            },
            class: 'col-md-12',
            hidden: true
          }, 
          {
            id: 'ADJ_DOC',
            placeholder: 'Examinar',
            name: 'Adjuntar Documento',
            type: 'file',
            values: '',
            validate: {
              required: false,
            },
            class: 'col-md-12',
            hidden: true
          }, 
          {
            id: 'DOC_1',
            placeholder: 'Examinar',
            name: 'Documento No. 1',
            type: 'file',
            values: '',
            validate: {
              required: false,
            },
            class: 'col-md-12',
            hidden: true
          }, 
          {
            id: 'DOC_2',
            placeholder: 'Examinar',
            name: 'Documento No. 2',
            type: 'file',
            values: '',
            validate: {
              required: false,
            },
            class: 'col-md-12',
            hidden: true
          }, 
          {
            id: 'DOC_3',
            placeholder: 'Examinar',
            name: 'Documento No. 3',
            type: 'file',
            values: '',
            validate: {
              required: false,
            },
            class: 'col-md-12',
            hidden: true
          },
           
          {
            id: 'DOC_4',
            placeholder: 'Examinar',
            name: 'Documento No. 4',
            type: 'file',
            values: '',
            validate: {
              required: false,
            },
            class: 'col-md-12',
            hidden: true
          }, 
          {
            id: 'DOC_5',
            placeholder: 'Examinar',
            name: 'Documento No. 5',
            type: 'file',
            values: '',
            validate: {
              required: false,
            },
            class: 'col-md-12',
            hidden: true
          }, 
          {
            id: 'DOC_6',
            placeholder: 'Examinar',
            name: 'Documento No. 6',
            type: 'file',
            values: '',
            validate: {
              required: false,
            },
            class: 'col-md-12',
            hidden: true
          }, 
          {
            id: 'DOC_7',
            placeholder: 'Examinar',
            name: 'Documento No. 7',
            type: 'file',
            values: '',
            validate: {
              required: false,
            },
            class: 'col-md-12',
            hidden: true
          }, 
          {
            id: 'DOC_8',
            placeholder: 'Examinar',
            name: 'Documento No. 8',
            type: 'file',
            values: '',
            validate: {
              required: false,
            },
            class: 'col-md-12',
            hidden: true
          }, 
          {
            id: 'DOC_9',
            placeholder: 'Examinar',
            name: 'Documento No. 9',
            type: 'file',
            values: '',
            validate: {
              required: false,
            },
            class: 'col-md-12',
            hidden: true
          },
          {
            id: 'DOC_10',
            placeholder: 'Examinar',
            name: 'Documento No. 10',
            type: 'file',
            values: '',
            validate: {
              required: false,
            },
            class: 'col-md-12',
            hidden: true
          },
          
          /* FINAL APARTADO PARA ARCHIVOS */
          {            
            id: 'IdTermiCondi',
            name: 'Términos y Condiciones',
            model: 'IdTermiCondi',
            type: 'accepted',  
            disabled: false,
            placeholder: 'Acepto los <a class="linkTerm" href="' + this.$store.state.linkTermiCondi + '" target="_blank">Términos y Condiciones</a> de uso.',
            values: '',
            validate: {              
              required: true,
            },
            class: 'col-md-12 linkref'           
          }                                                                
        ]
      },
      formUserFileModel: [],
    }
  }
}
</script>

<style scope>
.FormInscripcion {
  background-color: #fff;
}

.FormInscripcionOK .wizard-card-footer{
  display: none;
} 

.totalform {
  padding-top: 30px;
  padding-bottom: 30px;
  background-color: #ffffff;
}

.wizard-progress-with-circle {
  display: none !important;
}

.wizard-nav-pills, .wizard-card-footer{
  margin-left: 10% !important;   
  margin-right: 10% !important;
} 

.vue-form-generator, fieldset{
  display: contents;
}

.linkref{
  font-weight: bold;
  margin-bottom: 10px;
  margin-top: -5px;
}

#div_IdICFESText{
  font-weight: bold;
  margin-bottom: -20px;
  margin-top: -20px;
}

#div_IdAddressNumTxt, #div_IdAddressRefTxt{
  font-weight: bold;
  margin-bottom: -20px;
  margin-top: -10px;
  text-align: center;
}


.linkref a{
  color: #000 !important;
}

form-wizard
{
  border: #222 solid 2px;
  background-color: #fff;
  color: #222
}

.noShow{
  display: none;
}

.active
{
  color: #222;
}

#div_IdTermiCondi .titleRef, #div_IdHomolo .titleRef, #div_IdComproMatricula .titleRef{
  color: #ffffff;
  margin-top: 10px;
}

.titleRefSumary{
  font-weight: bold;
  text-transform: uppercase;
  text-decoration-line: underline;
  margin-top: 20px;
  margin-bottom: 20px;
}

.titleSumary{
    font-weight: bold;
}

.listSumary{
  font-size: 13px;
}
.botonRef {
  margin-top: 5px;
  max-width: 200px;
  color: #ffffff !important;
  background-color: #fff !important;
  border-color: #222 !important;
  font-size: 15px;
  font-weight: bold;
  -webkit-box-shadow: 10px 10px 41px -20px rgba(249, 195, 68, 1);
  -moz-box-shadow: 10px 10px 41px -20px rgba(249, 195, 68, 1);
  box-shadow: 10px 10px 41px -20px rgba(249, 195, 68, 1);
}

.botonPay {
  margin-top: 5px;
  max-width: 250px;
  color: #222 !important;
  background-color: #fff !important;
  border-color: #222 !important;
  font-size: 15px;
  font-weight: bold;
  -webkit-box-shadow: 10px 10px 41px -20px rgba(249, 195, 68, 1);
  -moz-box-shadow: 10px 10px 41px -20px rgba(249, 195, 68, 1);
  box-shadow: 10px 10px 41px -20px rgba(249, 195, 68, 1);
}

.btn:hover, .btn:focus {
color: #ffffff !important;
  background-color: #222 !important;
  border-color: #222 !important;
  font-size: 15px;
  font-weight: bold;
  -webkit-box-shadow: 10px 10px 41px -20px rgba(249,195,68,1);
  -moz-box-shadow: 10px 10px 41px -20px rgba(249,195,68,1);
  box-shadow: 10px 10px 41px -20px rgba(249,195,68,1);
}

.btn:active
{
  border-color: #A3A6AA !important;
  background-color: #A3A6AA !important;
  color: #fff;
}

.detalleAddress .is-invalid-form{
  display: none;
}

#sum_IdOperator, #sum_IdICFESText{
  display: none;
}

.botonData{
  margin-right: 10px;
  margin-bottom: 30px;
  margin-top: 20px;
}

body {
    background-color:  #fff;
}
header {
    background:  #ffffff;   
}

@media(min-width: 1024px)
{
  .flex-column
  {
    width: 800px;
    margin: 10px auto;
  }
}
</style>
